! function(t) {
	sgallery = {
		settings: {
			sattr: "class",
			showImgCount: !0,
			showThumbs: !1
		},
		bindEvents: function() {
			var e = this;
			e.settings;
			t(".gallery-box img").on("click.sg", function(s) {
				s.preventDefault(), e.SG.reset();
				var i = e.prepareData(t(this));
				e.prepareHTML(i)
			})
		},
		prepareData: function(e) {
			var s = this,
				i = s.settings;
			gname = e.attr(i.sattr);
			var n = [];
			return t(".gallery-box img").each(function(i, l) {
				l = t(l);
				var a = {};
				a.thumb = l.attr("src") || !1, a.full = l.attr("src") || !1, a.title = l.attr("title") || "", a.alt = l.attr("alt") || "", a.thumb && a.full && (n.push(a), l.is(e) && (s.SG.sindex = i))
			}), n
		},
		prepareHTML: function(e) {
			var s = this;
			if (s.SG.imgs = e, 0 != e.length) {
				for (var i in t(".SumoGallery").remove(), s.SG._SG = t('<div class="SumoGallery" style="display:none;">'), s.settings.showThumbs || s.SG._SG.addClass("nothumbs"), s.SG.title = t("<p>Sumo Gallery</p>"), s.SG.close = t('<a><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"/></svg></a>'), s.SG.body = t('<div class="Sbody">'), s.SG.footer = t('<div class="Sfooter">'), s.SG.thumbs = t('<ul class="Sthumbnails">'), s.SG.footer.append(s.SG.thumbs), s.SG.left = t('<a class="Sarrow l"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"/></svg></a>'), s.SG.right = t('<a class="Sarrow r"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="15px"><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"/></svg></a>'), s.SG.count = t('<p class="SimgCount"></p>'), s.SG.arrow = t('<a title="Toggle thumbnails." class="toggle-thumbs"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"/></svg></a>'), s.SG._SG.append(t('<div class="Sheader">').append(s.SG.title).append(s.SG.close)).append(s.SG.body).append(s.SG.footer).append(s.SG.left).append(s.SG.right), s.SG.footer.append(s.SG.arrow).append(s.SG.count), e) s.SG.body.append(t("<a>").append(t('<img alt="' + e[i].full + '" title="' + e[i].title + '" style="display:none;" />').on("load", function() {
					t(this).fadeIn(300)
				}).attr("src", e[i].full))), s.SG.thumbs.append("<li><a style=\"background-image:url('" + e[i].thumb + "')\"></a></li>");
				t("body").append(s.SG._SG), s.SG.init(), s.SG._SG.fadeIn(300)
			} else console.log("no images with appropriate data!!")
		},
		SG: {
			imgs: {},
			sindex: 0,
			reset: function() {
				this.sindex = 0
			},
			setEvents: function() {
				var e = this;
				e.close.on("click.sg", function() {
					t(".SumoGallery").fadeOut(300, function() {
						t(".SumoGallery").remove()
					}), t(document).off("keydown.sg")
				}), e.left.on("click.sg", function() {
					e.prev()
				}), e.right.on("click.sg", function() {
					e.next()
				}), e.thumbs.find("li>a").on("click.sg", function() {
					e.select(t(this).parent().index())
				}), e.body.find("a").on("swipeleft", function() {
					e.next()
				}), e.body.find("a").on("swiperight", function() {
					e.prev()
				}), e.arrow.on("click", function() {
					e._SG.toggleClass("nothumbs")
				}), t(document).on("keydown.sg", function(t) {
					switch (t.which) {
						case 37:
							e.prev();
							break;
						case 39:
							e.next();
							break;
						case 27:
							e.close.trigger("click.sg");
							break;
						default:
							return
					}
					t.preventDefault()
				})
			},
			select: function(t) {
				var e = this;
				if (!(t > e.imgs.length - 1 || t < 0)) {
					e.thumbs.children("li.sel").removeClass("sel"), e.thumbs.children("li").eq(t).addClass("sel");
					var s = e.thumbs.width() / 2 - e.thumbs.children("li").width() / 2;
					e.thumbs.stop().animate({
						scrollLeft: e.thumbs.children("li.sel").index() * e.thumbs.children("li").outerWidth(!0) - s
					});
					var i = e.body.children("a").eq(t),
						n = e.body.children("a.sel");
					n.length || i.addClass("sel anim"), t < this.sindex ? (n.addClass("right"), setTimeout(function() {
						n.removeClass("right sel anim")
					}, 300), i.removeClass("anim right").addClass("sel left"), setTimeout(function() {
						i.addClass("anim").removeClass("left")
					}, 5)) : t > this.sindex && (n.addClass("left"), setTimeout(function() {
						n.removeClass("left sel anim")
					}, 300), i.removeClass("anim left").addClass("sel right"), setTimeout(function() {
						i.addClass("anim").removeClass("right")
					}, 5)), this.sindex = t, e.title.text(i.children("img").attr("title")), sgallery.settings.showImgCount && e.count.text(t + 1 + " From " + e.imgs.length + " Image"), e.left.toggleClass("last-item", t < 1), e.right.toggleClass("last-item", t > e.imgs.length - 2)
				}
			},
			next: function() {
				this.select(this.sindex + 1)
			},
			prev: function() {
				this.select(this.sindex - 1)
			},
			init: function() {
				var t = this;
				t.setEvents(), t.select(t.sindex)
			}
		},
		init: function() {
			this.bindEvents()
		}
	}, sgallery.init()
}(jQuery);